import { render, staticRenderFns } from "./iconTouch.vue?vue&type=template&id=23e3bb18&scoped=true"
import script from "./iconTouch.vue?vue&type=script&lang=js"
export * from "./iconTouch.vue?vue&type=script&lang=js"
import style0 from "./iconTouch.vue?vue&type=style&index=0&id=23e3bb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e3bb18",
  null
  
)

export default component.exports